import React from 'react';
import styles from './styles/CartItem.module.css';
import { QuantitySelector } from './qtySelector';
import { calculateUnitPrice, getCurrencySymbol } from './utils/calcPrice';
import { X } from 'lucide-react';

export const CartItem = ({ item, onQuantityChange, onRemove }) => {
  console.log(item);
  const handleQuantityChange = (newQty) => {
    onQuantityChange(item._id, newQty);
  };

  const handleRemove = () => {
    onRemove(item._id);
  };

  const { unitPrice, prevPrice, totalPrice } = calculateUnitPrice(item);
  const quantity = item.quantity;

  return (
    <div className={styles.itemWrapper}>
      <button className={styles.button} onClick={handleRemove}>
        <X size={18} />
      </button>
      <div className={styles.itemContent}>
        <div className={styles.imageWrapper}>
          <img src={item.pic} className={styles.image} />
        </div>
        <div className={styles.textWrapper}>
          <span className={styles.title}>{item.title}</span>
          <span className={styles.desc}>{item.composition}</span>
        </div>
      </div>
      <div className={styles.footer}>
        <div className={styles.price}>
          {item.price_r.includes('You can purchase from') && item.price_w.includes('You can purchase from') ? (
            <div>
              <p className={styles.dist}>Distributor contacts will be provided by sales manager.</p>
            </div>
          ) : unitPrice !== prevPrice ? (
            <div>
              <span className={styles.strike}>
                {getCurrencySymbol(item.country, 0)}
                {(prevPrice * quantity).toFixed(2)}
              </span>
              &nbsp;
              <span>${totalPrice.toFixed(2)}</span>
            </div>
          ) : (
            <div>${totalPrice.toFixed(2)}</div>
          )}
        </div>
        <div className={styles.qty}>
          <QuantitySelector value={quantity} onChange={handleQuantityChange} />
        </div>
      </div>
    </div>
  );
};
